/**
 * Body + axios config for list-fetch POSTs (`/api/ms1/`, `/api/content/`).
 * The handlers ignore the body; auth is the JWT header.
 * Never send `false`/`null` — axios defaults Content-Type to application/json
 * and express.json({ strict: true }) 400s on non-object JSON.
 */
export function gatherListRequest(user) {
  const axiosConfig = {
    timeout: 60000,
    headers: {},
  };
  if (user && user.token) {
    axiosConfig.headers.Authorization = "JWT " + user.token;
  }
  return { body: {}, axiosConfig };
}
